import { FormattedMessage, useIntl } from 'react-intl';
import { Icon, Tooltip } from '@ets/design-system';

import DOMElementFactory from 'Editor/services/DOMUtilities/DOMElementFactory/DOMElementFactory';
import { DISPLAY_TYPES, ELEMENTS } from 'Editor/services/consts';
import styles from './KeywordsElement.module.scss';
import { BaseBlockElement } from '../../BaseViewBuilder';
import { StylesUtils } from 'Editor/services/Edition_v2/Managers/Styles/StylesUtils';
import { Root } from 'react-dom/client';
import ReactUtils from '_common/utils/ReactUtils';

const KeywordsElementContent = () => {
  const intl = useIntl();

  return (
    <Tooltip
      content={intl.formatMessage({ id: 'CONTENT_CANNOT_BE_EDITED' })}
      testId="keywords-cannot-be-edited"
    >
      <div className={styles.contentWrapper}>
        <div className={styles.iconWrapper}>
          <Icon icon="list" size="4" testId="keywords" />
        </div>
        <div className={styles.info}>
          <FormattedMessage id={'EDITOR_DOCUMENT_KEYWORDS'} />
        </div>
      </div>
    </Tooltip>
  );
};
export class KeywordsElement extends BaseBlockElement {
  private container?: HTMLElement;
  private rootReactContainer?: Root;

  get selectableContent() {
    return this.container?.childNodes[0]?.childNodes[1] || null;
  }

  connectedCallback() {
    super.connectedCallback();
    this.buildElement();
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    ReactUtils.unmountReactComponent(this.rootReactContainer);
  }

  get ALLOWED_STYLE_ATTRIBUTES() {
    return StylesUtils.getAllowedBlockStyles('k');
  }

  get displayType() {
    return DISPLAY_TYPES.BLOCK;
  }

  get isEditable() {
    return false;
  }

  get isDeletable() {
    return !this.isLocked;
  }

  get isSplitable() {
    return false;
  }

  get isSelectable() {
    return true;
  }

  buildElement() {
    this.innerHTML = '';

    // this.setAttribute('contentEditable', false);
    this.setAttribute('spellcheck', 'false');

    //Container test if can be used because is used on selected method
    this.container = DOMElementFactory.buildElement('div');
    this.container.setAttribute('class', styles.container);

    this.appendChild(this.container);

    this.rootReactContainer = ReactUtils.createReactRoot(this.container);
    ReactUtils.renderReactComponent(<KeywordsElementContent />, this.rootReactContainer);
  }
}

if (!window.customElements.get(ELEMENTS.KeywordsElement.IDENTIFIER)) {
  window.customElements.define(ELEMENTS.KeywordsElement.IDENTIFIER, KeywordsElement);
}
